import { useEffect, useState } from "react";
import Table from "../../Reusable/Table/Table1";
import {
  CheckCircleOutlined,
  EditOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import DropdownButton from "../../Reusable/dropdown/Drop";
import ReusableModal from "../../Reusable/Model/Model";
import ReusableDrawer from "../../Reusable/Drawer/Drawer";
import { Form, Input, Radio, InputNumber, Tag, Tabs, Card, Typography, Button, message } from "antd";
import CustomSelect from "../../Reusable/Select/Select";
import AvatarUploader from "../../Reusable/Avatar/Avatar";
import axios from "axios";
import consts from "../../constant";
import Loadingpage from "../Loadingpage/Loadingpage";

const { Title, Text } = Typography;

const WinPercent = () => {
  const [perc, setPerc] = useState({});
  const [messageApi, contextHolder] = message.useMessage();
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [activeRole, setActiveRole] = useState("basic");

  const setWinPerc = async () => {
    setLoading(true);
    try {
      const payload = {
        percent: value,
        role: activeRole,
      };
      const { data } = await axios.post(
        `${consts.BackendUrl}/set-profitPerc`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        },
      );
      if (data?.success) {
        messageApi.open({
          type: "success",
          content: data?.message,
        });
        getPerc(activeRole);
      } else {
        messageApi.open({
          type: "error",
          content: data?.message,
        });
      }
    } catch (err) {
      messageApi.open({
        type: "error",
        content: err?.response?.data?.message || err.message || "Failed to upload Profit Percentage",
      });
    } finally {
      setLoading(false);
    }
  };

  const getPerc = async (role = activeRole) => {
    try {
      const { data } = await axios.post(
        `${consts.BackendUrl}/get-profitPerc`,
        { role },
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        }
      );
      if (data?.success) {
        setPerc(data?.result);
        setValue(data?.result?.percent || "");
      } else {
        setPerc({});
        setValue("");
      }
    } catch (err) {
      setPerc({});
      setValue("");
    }
  };

  useEffect(() => {
    getPerc(activeRole);
  }, [activeRole]);

  return (
    <>
      <Loadingpage />
      <div className="display-2 p-10">
        <h2>Winning Profit Percentage:</h2>
      </div>

      <div style={{ padding: "0 40px", marginBottom: "20px" }}>
        <Radio.Group 
          value={activeRole} 
          onChange={(e) => setActiveRole(e.target.value)}
          buttonStyle="solid"
        >
          <Radio.Button value="basic">Basic</Radio.Button>
          <Radio.Button value="vip">VIP</Radio.Button>
          <Radio.Button value="vvip">VVIP</Radio.Button>
        </Radio.Group>
      </div>

      <div style={{ padding: "0 40px" }}>
        <Input
          placeholder="Enter Amount Percentage"
          style={{ width: 250 }}
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
        <Button
          type="primary"
          style={{ marginLeft: 10 }}
          onClick={() => setWinPerc()}
          loading={loading}
        >
          Update
        </Button>
      </div>
      <div className="p-10 mt-20" style={{ color: "white" }}>
        <div>
          <b>Current {activeRole.toUpperCase()} Win Percentage : </b>
          {perc?.percent ? perc?.percent : 0} %
        </div>
      </div>
      {contextHolder}
    </>
  );
};

export default WinPercent;
